module.exports = __webpack_public_path__ + "static/media/ic_zoom.1dd717cb.svg";